module.exports = __webpack_public_path__ + "assets/img/dimensions.290708a5.svg";